import React, { useEffect, useMemo, useState } from 'react';
import { useApp } from 'context/AppContext';
import { Goods } from 'components';
import { helper } from 'utils';
import background_vip from 'assets/vip_box.png';

import {
  VipCard,
  HeaderImage,
  VipRibbon,
  TimerTag,
  BodyContent,
  InputField,
  DebugId,
  VipRibbonText,
  ErrorText,
  GiftSelectedContainer,
  GiftSelectedIcon,
  GiftSelectedText,
} from './Styles';

import { Button } from 'styles/AppStyles';
import { currentGameConfig } from 'utils/handleCurrentContentConfig';

const CAMPAIGN_CODE = 'vip2025';

const VipBonus = ({ vipBonus, onExpire }) => {
  const { openModal, state } = useApp();
  const [code, setCode] = useState('');
  const [isError, setIsError] = useState(false);
  const { vipBonusClaimed } = state;
  const { gLt, izid, vLt, vae, src } = vipBonus || {};

  const handleConfirm = () => {
    if (!code) return;
    if (code.trim().toLowerCase() !== CAMPAIGN_CODE) {
      setIsError(true);
      return;
    }

    openModal({ modal: 'vipBonus', data: { gLt, vae } });
  };

  const bgImg = useMemo(() => {
    const { fileHost } = currentGameConfig;
    return src ? fileHost + src : background_vip;
  }, [src]);

  return (
    <VipCard>
      <HeaderImage $bgImage={bgImg}>
        <VipRibbon>
          <VipRibbonText>VIP</VipRibbonText>
        </VipRibbon>
        {!!vLt && <StorePackTimer state={vLt} onExpire={onExpire} />}
        {helper.isDebugMode && <DebugId>{izid}</DebugId>}
      </HeaderImage>

      <BodyContent>
        {vipBonusClaimed ? (
          <>
            <GiftSelectedContainer>
              <GiftSelectedIcon />
            </GiftSelectedContainer>
            <GiftSelectedText>Gift claimed</GiftSelectedText>
          </>
        ) : (
          <>
            {gLt && <Goods goods={gLt} withStyle />}

            <InputField
              placeholder="Enter code"
              value={code}
              maxLength={10}
              onChange={e => {
                setCode(e.target.value);
                if (isError) setIsError(false);
              }}
            />
            {isError && (
              <ErrorText style={{ marginTop: '0.3rem', color: 'red' }}>
                Sorry, this code can't be applied. it may be incorrect or inactive
              </ErrorText>
            )}
            <Button onClick={handleConfirm}>Confirm</Button>
          </>
        )}
      </BodyContent>
    </VipCard>
  );
};

export default VipBonus;

const StorePackTimer = ({ state, onExpire }) => {
  const [timer, setTimer] = useState('');

  useEffect(() => {
    if (!(state && 'exs' in state)) return;

    const timerId = setInterval(() => {
      const exs = state.exs;

      const now = Date.now() / 1000;

      if (now > exs) {
        setTimer('');
        if (onExpire) onExpire();
        return;
      }

      const diff = exs - now;

      const toTimeFormat = value => (value < 10 ? '0' + value : value);

      if (diff >= 48 * 60 * 60) {
        setTimer('');
      } else {
        const h = parseInt(diff / 60 / 60, 10);
        const m = parseInt((diff / 60) % 60, 10);
        const s = parseInt(diff % 60, 10);

        setTimer(`${toTimeFormat(h)}:${toTimeFormat(m)}:${toTimeFormat(s)}`);
      }
    }, 1000);

    return () => {
      clearInterval(timerId);
    };
  }, [state, onExpire]);

  if (!timer) return null;

  return <TimerTag>{timer}</TimerTag>;
};
